import { ObjectValues } from "@/src/shared/types/objectValues";

export const DS_BADGE_POSITION = {
  Inline: "inline",
  TopRight: "top-right",
  BottomRight: "bottom-right",
} as const;

export type DSBadgePosition = ObjectValues<typeof DS_BADGE_POSITION>;
